class Slider {
	current = 0;
	max_move = 0;
	moving_dis = 0;

	constructor(block) {
		this.limit_area = block.querySelector(".sui-post-slider-limits");
		this.cards = block.querySelectorAll(".sui-post-slider-card");
		this.slider = block.querySelector(".sui-post-slider-layout");
		this.prev_btn = block.querySelector(".sui-post-sldier-left");
		this.next_btn = block.querySelector(".sui-post-sldier-right");

		this.prev_btn.addEventListener("click", () => {
			this.update(-1);
		});

		this.next_btn.addEventListener("click", () => {
			this.update(1);
		});

		this.updateSettings();

		window.addEventListener("resize", () => {
			this.updateSettings();
		});
	}

	update(direction) {
		this.current += direction;
		this.current = this.current < 0 ? 0 : this.current;
		this.current = this.current > this.max_move ? this.max_move : this.current;

		this.updateActiveClass(this.prev_btn, this.current > 0);
		this.updateActiveClass(this.next_btn, this.current !== this.max_move);

		this.updateSlider(this.moving_dis * this.current);
	}

	updateActiveClass(elem, isActive) {
		if (isActive) {
			elem.classList.add("sui-active");
		} else {
			elem.classList.remove("sui-active");
		}
	}

	updateSlider(value) {
		this.slider.style.transform = `translateX(-${value}px)`;
	}

	updateSettings() {
		const { limits, first_rect, last_rect } = this.getAllRects();

		this.current = 0;
		this.moving_dis = first_rect.width + 20;

		let valid_moves = Math.trunc(limits.width / this.moving_dis);
		valid_moves = this.cards.length - valid_moves;

		this.max_move = valid_moves;

		this.updateSlider(0);
		this.updateActiveClass(this.prev_btn, false);
		this.updateActiveClass(this.next_btn, true);
	}

	getAllRects() {
		const limits = this.getRect(this.limit_area);
		const first_rect = this.getRect(this.cards[0]);
		const last_rect = this.getRect(this.cards[this.cards.length - 1]);

		return {
			limits: limits,
			first_rect: first_rect,
			last_rect: last_rect,
		};
	}

	getRect(elem) {
		return elem.getClientRects()[0];
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const blocks = document.querySelectorAll('[sui-block="sui/post-slider"]');

	blocks.forEach((block) => {
		if (block.hasAttribute("data-initialized")) return;
		block.setAttribute("data-initialized", "true");

		new Slider(block);
	});
});
